module.exports = __webpack_public_path__ + "img/lemonade.be5030ca.webp";